import { fetchBaaStatus } from "@app/agreements";
import { selectOrganizationSelectedId } from "@app/organizations";
import { useQuery, useSelector } from "@app/react";
import { settingsLegalAgreementsUrl } from "@app/routes";
import { schema } from "@app/schema";
import type { AgreementSummary } from "@app/types";
import { useMemo } from "react";
import { Link } from "react-router-dom";
import { Banner } from "./banner";

export function SignBaaBanner() {
  const orgId = useSelector(selectOrganizationSelectedId);

  const baaFetchAction = useMemo(() => fetchBaaStatus({ orgId }), [orgId]);
  useQuery(baaFetchAction);

  const baaSummary = useSelector((s) =>
    schema.cache.selectById(s, { id: baaFetchAction.payload.key }),
  ) as AgreementSummary | undefined;
  const baaStatus = baaSummary?.status;

  const showBanner = baaStatus !== undefined && baaStatus !== "SIGNED";

  if (!showBanner) {
    return null;
  }

  return (
    <Banner variant="warning">
      Review & Sign: An updated BAA is available. Please execute it through the
      new{" "}
      <Link to={settingsLegalAgreementsUrl()} className="underline font-medium">
        Agreements page
      </Link>
      . Once executed, the BAA will be available in the dashboard for download.
    </Banner>
  );
}
